import React from 'react';
import ServicePageTemplate from '../../components/ServicePageTemplate';
import { Cloud } from 'lucide-react';
import { servicePricing } from '../../mockData';

const CloudSolutions = () => {
  const features = [
    {
      title: "Cloud Migration",
      description: "Smooth transition from on-premise to cloud infrastructure"
    },
    {
      title: "Infrastructure Setup",
      description: "Design and deploy scalable cloud architecture on AWS, Azure, or GCP"
    },
    {
      title: "DevOps & CI/CD",
      description: "Automated deployment pipelines for faster, reliable releases"
    },
    {
      title: "Container Orchestration",
      description: "Docker and Kubernetes for scalable microservices"
    },
    {
      title: "Monitoring & Alerts",
      description: "24/7 monitoring with automatic alerts for issues"
    },
    {
      title: "Cost Optimization",
      description: "Reduce cloud spending with resource optimization strategies"
    }
  ];

  const benefits = [
    {
      title: "Unlimited Scalability",
      description: "Scale up or down instantly based on demand without infrastructure limits"
    },
    {
      title: "High Availability",
      description: "99.9% uptime with automatic failover and disaster recovery"
    },
    {
      title: "Pay As You Go",
      description: "Only pay for resources you actually use, no upfront hardware costs"
    },
    {
      title: "Global Reach",
      description: "Deploy to multiple regions worldwide for low latency everywhere"
    }
  ];

  const process = [
    {
      title: "Assessment & Planning",
      description: "Analyze current infrastructure and design cloud architecture"
    },
    {
      title: "Migration Strategy",
      description: "Plan phased migration with minimal downtime"
    },
    {
      title: "Implementation",
      description: "Set up cloud infrastructure and migrate applications"
    },
    {
      title: "Optimization & Support",
      description: "Continuous monitoring, optimization, and technical support"
    }
  ];

  const cloudPricing = [
    {
      id: 1,
      name: "Cloud Setup",
      price: "$4,500",
      period: "one-time",
      description: "Initial cloud infrastructure setup",
      features: [
        "AWS/Azure/GCP setup",
        "Basic infrastructure design",
        "Application deployment",
        "CI/CD pipeline",
        "Documentation",
        "2-month support"
      ],
      color: "#ff84e4",
      popular: false
    },
    {
      id: 2,
      name: "Cloud Migration",
      price: "$12,000",
      period: "starting at",
      description: "Complete cloud migration service",
      features: [
        "Infrastructure assessment",
        "Migration planning",
        "Data migration",
        "Application migration",
        "Testing & optimization",
        "Team training",
        "4-month support"
      ],
      color: "#d987ff",
      popular: true
    },
    {
      id: 3,
      name: "Managed Cloud",
      price: "$3,500/mo",
      period: "ongoing",
      description: "Full cloud management service",
      features: [
        "24/7 monitoring",
        "Automatic scaling",
        "Security updates",
        "Performance optimization",
        "Cost management",
        "Dedicated DevOps engineer",
        "Priority support"
      ],
      color: "#88a2ff",
      popular: false
    }
  ];

  return (
    <ServicePageTemplate
      title="Cloud Solutions"
      subtitle="Scale Without Limits"
      description="Deploy and manage your applications on AWS, Azure, or Google Cloud. From initial setup to complete managed services, we handle your cloud infrastructure."
      features={features}
      benefits={benefits}
      pricing={cloudPricing}
      icon={Cloud}
      bgColor="#ff84e4"
      process={process}
    />
  );
};

export default CloudSolutions;